import { useTranslation } from "react-i18next";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";

export default function About() {
  const { t } = useTranslation();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section id="about" className="w-full py-16 md:py-24 bg-[#F8F7F5]">
      <div ref={ref} className="w-full px-4 md:px-8 lg:px-12">
        <div className="mb-12 md:mb-16">
          <motion.span
            className="text-sm font-medium text-[#8B7355] tracking-wide uppercase mb-4 block"
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 0.5, ease: [0.25, 0.1, 0.25, 1] }}
          >
            {t("about.label")}
          </motion.span>

          <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold text-stone-900 leading-tight">
            <motion.span
              className="block"
              initial={{ opacity: 0, y: 40 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
              transition={{ duration: 0.6, delay: 0.1, ease: [0.25, 0.1, 0.25, 1] }}
            >
              {t("about.line1")}
            </motion.span>
            <motion.span
              className="block italic font-serif text-stone-700"
              initial={{ opacity: 0, y: 40 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
              transition={{ duration: 0.6, delay: 0.2, ease: [0.25, 0.1, 0.25, 1] }}
            >
              {t("about.line2")}
            </motion.span>
            <motion.span
              className="block"
              initial={{ opacity: 0, y: 40 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
              transition={{ duration: 0.6, delay: 0.3, ease: [0.25, 0.1, 0.25, 1] }}
            >
              {t("about.line3")}
            </motion.span>
          </h2>

          <motion.p
            className="mt-4 text-base md:text-lg text-stone-600"
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
            transition={{ duration: 0.5, delay: 0.4, ease: [0.25, 0.1, 0.25, 1] }}
          >
            {t("about.subtitle")}
          </motion.p>
        </div>
      </div>
    </section>
  );
}